<template>
    <slot v-if="$store.state.isLoggedIn"/>
    <slot v-else name="else"/>
</template>

<script setup lang="ts">
</script>
